export default __webpack_public_path__ + "media/zurb/img/b2b_ecommerce/pdp_image-580f202c11ea73bcab6c3d1fde28119c.png";